<ng-container *ngIf="userHasLoaded">
  <app-side-menu></app-side-menu>
</ng-container>
